export default {
  SET_LOADING(state, value) {
    state.loading = value
  },

  SET_ERROR(state, error) {
    state.error = error
  },

  SET_INVOICES(state, data) {
    state.invoices = data
  },

  SET_INVOICE(state, data) {
    state.invoice = data.data
  },

  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters }
  },

  SET_PAGINATION(state, data) {
    state.pagination = {
      total: data.total,
      current_page: data.current_page,
      last_page: data.last_page
    }
  }
}